import React from 'react';
import PropTypes from 'prop-types';
import styles from './InlineTooltip-hashed.scss';
import cx from 'classnames';
import getIconClasses from '../../iconUtils';
import defaultTranslator from '@elixir/translator';

/**
 * A psuedo static tooltip
 * Note: this displays a block. it does not have the show/hide functionality of a Tooltip
 */
class InlineTooltip extends React.Component {
    static propTypes = {
        /**
        * The paragraph text
        **/
        text: PropTypes.string,
        /**
        * The title to be displayed at the head of the inlineTooltip
        **/
        title: PropTypes.string,
        /**
        * The text of the link
        **/
        link: PropTypes.string,
        /**
        * The URL that the link points to
        **/
        href: PropTypes.string,
        /**
        * The icon display after the link text
        **/
        linkIcon: PropTypes.string,
    };

    /**
        * Used here to obtain the translator function for localizing strings
        *
        * @type {Object}
        * @property {function(key: string)} translator - The function used to translate strings
        */
    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    renderTitle() {
        const {title} = this.props;
        const translator = this.context.translator || defaultTranslator;

        return title ?
            <h2>{translator(title)}</h2>
            : null;
    }

    renderText() {
        const {text} = this.props;
        const translator = this.context.translator || defaultTranslator;

        return text ?
            <p className={styles.text}>{translator(text)}</p>
            : null;
    }

    renderLink() {
        const {
            href, link, linkIcon
        } = this.props;
        const translator = this.context.translator || defaultTranslator;

        const iconClasses = linkIcon && cx(styles.icon, getIconClasses(linkIcon));

        const icon = linkIcon ?
            (<i className={iconClasses} />)
            : null;

        return (link && href) ?
            <a href={href} className={styles.link} target="_blank">{translator(link)}{icon}</a>
            : null;

    }

    render() {
        const {className} = this.props;
        const classes = cx(styles.inlineTooltip, className);
        return (
            <div className={classes}>
                {this.renderTitle()}
                {this.renderText()}
                {this.renderLink()}
            </div>
        );
    }

}

export default InlineTooltip;
